import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";

import { CURRENCY_SIGNS, dateFormatter } from "../../hooks/HelperFunctions";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import Link from "next/link";
import Buttons from "../Button/Button";
import ModalTwo from "../Modals/ModalTwo";
import ShareThisCourse from "../ShareThisCourse/ShareThisCourse";
import Button from "@mui/material/Button";
import CustomizedSnackbar from "../../hooks/Snackbar";
import FBIcon from "../../assets/imgs/socialIcon/FBShaere.png";
import styles from "./Session.module.css";
import Image from "next/image";
import AddToCartBottomModal from "./AddToCartBottomModal";
import Drawer from "@mui/material/Drawer";
import moment from "moment-timezone";
import { useShoppingCart } from "../../contexts/CartContext";
import SideDrawer from "../../pages/Payments/compononents/SideDrawer/SideDrawer";
import ShoppingCart from "../../pages/Payments/forms/ShoppingCart";
import ModalsResponsiveFullScreen from "../Modals/ModalsResponsiveFullScreen";
import { useSelector } from "react-redux";

function CourseCard(props) {
  const {
    courses,
    setUpdateCart,
    cardBtn,
    enrollNowHandler,
    setOpenSignUpModel,
  } = props;

  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // severity can be: success, error, warning, info, success
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [addToCartBtnLink, setAddToCartBtnLink] = useState(false);
  const [addToCartBtnLabel, setAddToCartBtnLabel] = useState({});
  const [addToCartBtnLabelForGoToCourse, setAddToCartBtnLabelForGoToCourse] =
    useState({});
  const { cartItems, setCartItems, cartItemsCoupons, setCartItemsCoupons } =
    useShoppingCart();
  const [userData, setUserData] = useState([]);

  // ====== Payment Drawer Start======//
  const [openShoppingDrawer, setOpenShoppingDrawer] = useState(false);
  const handleOpenShoppingDrawer = () => {
    setOpenShoppingDrawer(true);
  };
  const CloseShoppingDrawer = () => {
    setOpenShoppingDrawer(false);
  };
  // ====== Payment Drawer End======//

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  }, []);

  /**
   * When click on snackbar close btn
   */
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  const [currentCourseData, setCurrentCourseData] = useState({});

  const [cartCourse, setCartCourse] = useState([]);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const localData = window.localStorage.getItem("selectedCourses");
      if (localData) {
        setCartCourse(JSON.parse(localData));
      }
    }
  }, []);

  const [maxCoursesShow, setMaxCoursesShow] = useState(6);

  // max courses array size
  const coursesArrSize = courses.length;
  // course card data
  let courseCards = courses;
  if (maxCoursesShow == 6) {
    courseCards = courses.slice(0, 6);
  }

  // show/hide show all btn
  let showAllBtnStatus = true;
  if (coursesArrSize <= 6 || courses.length == courseCards.length) {
    showAllBtnStatus = false;
  }

  const showAllBtnHandler = () => {
    setMaxCoursesShow(999);
  };

  useEffect(() => {
    localStorage.setItem("selectedCourses", JSON.stringify(cartCourse));
    if (typeof setUpdateCart === "function") {
      setUpdateCart(true);
    }
  }, [cartCourse]);

  // useEffect(() => {
  //   const localCourses = JSON.parse(localStorage.getItem("selectedCourses"));

  //   if (localCourses) {
  //     localCourses.forEach((item) => {
  //       let updateAddToCartLabel = {};
  //       updateAddToCartLabel[item.courseId] = "Go to cart";

  //       setAddToCartBtnLabel((addToCartBtnLabel) => ({
  //         ...addToCartBtnLabel,
  //         ...updateAddToCartLabel,
  //       }));
  //     });
  //   }
  // }, []);
  useEffect(() => {
    if (cartItems) {
      const updatedLabels = {};
      cartItems?.map((item) => {
        updatedLabels[item?.courseId] = "Go to cart";
      });
      setAddToCartBtnLabel(updatedLabels);
    }
  }, [cartItems]);

  useEffect(() => {
    const interval = setInterval(() => {
      // call alrady enrolled course data process function
      const userAuthenticated = localStorage.getItem("userAuthenticated");
      if (userAuthenticated) {
        updateAlreadyEnrolledCourseList();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const updateAlreadyEnrolledCourseList = () => {
    const alreadyEnrolledCourses = JSON.parse(
      localStorage.getItem("alreadyEnrolledCourses")
    );

    if (alreadyEnrolledCourses) {
      // console.log("Inside condition",alreadyEnrolledCourses);
      alreadyEnrolledCourses?.forEach((item) => {
        let updateAddToCartLabel = {};
        updateAddToCartLabel[item.courseId] = "Go to Course";

        setAddToCartBtnLabelForGoToCourse((addToCartBtnLabelForGoToCourse) => ({
          ...addToCartBtnLabelForGoToCourse,
          ...updateAddToCartLabel,
        }));
      });
    }
  };

  const addToCartHandler = (item) => {
    if (addToCartBtnLabel[item.courseId]) {
      // var base_url = window.location.origin;
      // window.location.href = base_url + "/shopping";
      handleOpenShoppingDrawer();
    } else {
      setAddToCartBtnLink(true);

      let updateAddToCartLabel = {};
      updateAddToCartLabel[item.courseId] = "Go to cart";

      const cartPaymentInfo = JSON.parse(
        localStorage.getItem("cartPaymentInfo")
      );

      let found = 0;

      //this section search course already exists in a cart or not. if exists it increase the found
      cartPaymentInfo?.map((singleCartitem) => {
        if (singleCartitem?.courses && singleCartitem?.courses?.length > 0) {
          singleCartitem?.courses?.map((course) => {
            if (course?.course?.courseId == item?.courseId) {
              found++;
            }
          });
        }
      });

      if (found > 0) {
        setShowSnackbar(true);
        setSnackbarSeverity("error");
        setSnackbarMessage("Course already added to a track.");
        return false;
      }

      let independentCourseIdsWithCoupons = null;

      if (cartItemsCoupons?.length > 0) {
        let found = cartItemsCoupons?.find(
          (single) => single.courseId == item?.courseId
        );
        if (found) {
          let addedItemsCoupons = item?.active_coupons
            ?.filter(
              (coupon) =>
                coupon.apply_automatically === true &&
                (coupon.applies_for === "everyone" ||
                  (coupon.applies_for === "selected_users" &&
                    userData?.id &&
                    Array.isArray(coupon.user_ids) &&
                    coupon.user_ids.includes(userData.id)))
            )
            .map((coupon) => coupon.id);

          let uniqueCouponIds = [
            ...new Set([...found?.couponIds, ...addedItemsCoupons]),
          ];

          independentCourseIdsWithCoupons = {
            courseId: item?.courseId,
            couponIds: uniqueCouponIds,
          };
        } else {
          let addedItemsCoupons = item?.active_coupons
            ?.filter(
              (coupon) =>
                coupon.apply_automatically === true &&
                (coupon.applies_for === "everyone" ||
                  (coupon.applies_for === "selected_users" &&
                    userData?.id &&
                    Array.isArray(coupon.user_ids) &&
                    coupon.user_ids.includes(userData.id)))
            )
            .map((coupon) => coupon.id);

          independentCourseIdsWithCoupons = {
            courseId: item?.courseId,
            couponIds: addedItemsCoupons,
          };
        }
      } else {
        let addedItemsCoupons = item?.active_coupons
          ?.filter(
            (coupon) =>
              coupon.apply_automatically === true &&
              (coupon.applies_for === "everyone" ||
                (coupon.applies_for === "selected_users" &&
                  userData?.id &&
                  Array.isArray(coupon.user_ids) &&
                  coupon.user_ids.includes(userData.id)))
          )
          .map((coupon) => coupon.id);
        independentCourseIdsWithCoupons = {
          courseId: item?.courseId,
          couponIds: addedItemsCoupons,
        };
      }

      setAddToCartBtnLabel((addToCartBtnLabel) => ({
        ...addToCartBtnLabel,
        ...updateAddToCartLabel,
      }));
      setCartItems([item, ...cartItems]);
      setCartCourse([...cartCourse, item]);
      if (independentCourseIdsWithCoupons?.couponIds?.length > 0) {
        setCartItemsCoupons([
          ...cartItemsCoupons,
          independentCourseIdsWithCoupons,
        ]);
      }

      // setUpdateCart(true);
      setShowSnackbar(true);
      setSnackbarSeverity("success");
      setSnackbarMessage("Course added to the cart.");
      localStorage.setItem(
        "cartPaymentInfo",
        JSON.stringify([item, ...cartItems])
      );
      if (independentCourseIdsWithCoupons?.couponIds?.length > 0) {
        localStorage.setItem(
          "itemsCoupons",
          JSON.stringify([independentCourseIdsWithCoupons, ...cartItemsCoupons])
        );
      }
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = (item) => {
    setCurrentCourseData(item);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const gotoCourseDetails = (courseId) => {
    // redirect to portal's auto sign in page
    const portalUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
        : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;
    const userToken = localStorage.getItem("userToken");
    const tokenData = { email: userData.email, userToken: userToken };
    var token = CryptoJS.AES.encrypt(
      JSON.stringify([tokenData]),
      "login-854256-secret-key"
    ).toString();
    console.log(token);
    if (typeof window !== "undefined") {
      const path = `&courseDetailId=${courseId}`;
      window.location.replace(`/course-details-learner/${courseId}`);
      // window.location.replace(
      //   `${portalUrl}/token-based-signin?token=${token}${path}`
      // );
    }
  };

  const today = moment();

  const getAddToCartToolTip = (course) => {
    const enrollmentStartDate = new Date(course.enrollmentStartDate);
    // For pre-recorded courses, enrollmentEndDate is optional - only check if it exists
    const enrollmentEndDate = course.enrollmentEndDate ? new Date(course.enrollmentEndDate) : null;
    // console.log(
    //   "enrollmentStartDate",
    //   enrollmentStartDate,
    //   "enrollmentEndDate",
    //   enrollmentEndDate
    // );
    if (
      course.seatsStatus &&
      course.seats &&
      course.totalEnrolled >= course.seats
    ) {
      return "The course has reached its maximum enrollment capacity";
    } else if (today < enrollmentStartDate) {
      // Options for formatting the date
      const options = { year: "numeric", month: "short", day: "numeric" };

      // Format the date
      const formattedDate = enrollmentStartDate.toLocaleDateString(
        "en-US",
        options
      );

      return `Enrollment starts on ${formattedDate}`;
    } else if (enrollmentEndDate && today > enrollmentEndDate) {
      // Only check enrollment end date if it exists (for live courses or pre-recorded with end date)
      // Options for formatting the date
      const options = { year: "numeric", month: "short", day: "numeric" };

      // Format the date
      const formattedDate = enrollmentEndDate.toLocaleDateString(
        "en-US",
        options
      );

      return `Enrollment closed on ${formattedDate}`;
    } else {
      return "";
    }
  };

  const getTheCorrectCurrencySign = () => {
    return CURRENCY_SIGNS[activeCurrency] ?? "$";
  };

  const showSessionStartDate = (item) => {
    if (!item?.sessionStartDate) return null;
  
    return (
      <>
        Starts:{" "}
        {dateFormatter(
          item.sessionStartDate,
          item.timezone,
          "ddd, MMM D z"
        )}{" "}
      </>
    );
  };
  return (
    <>
      {courseCards?.map((item, i) => (
        <Grid item xs={12} sm={6} md={4}>
          <div className={styles.SessionCard}>
            <div className={styles.SessionCardImg}>
              {/* {item.courseStreamingStatus == "" ? (
                ""
              ) : (
                <span className={styles.StatusTwo}>
                  {item.courseStreamingStatus}{" "}
                </span>
              )} */}
              <a
                href={`/learn/${item?.courseSlug}`}
                className={styles.CardImageContainer}
              >
                {item?.courseImage ? <img src={item?.courseImage} /> : <></>}
              </a>
            </div>

            <div className={styles.SessionCardInfo}>
              <div className={styles.SessionCardDate}>
                <h3>
                  {(!item.enrollmentEndDate ||
                        today?.isBefore(moment(item?.enrollmentEndDate))) &&
                      showSessionStartDate(item)}
                  {/* {moment(item?.sessionStartDate)?.format("ddd, MMM DD, YYYY")} */}
                </h3>
                <span data-id={item?.price == "Free" ? 0 : item.price}>
                  {item.price == "Free" ? "Free" : getTheCorrectCurrencySign() + item.price}
                </span>
              </div>
              <h1>
                <a href={`/learn/${item?.courseSlug}`}>{item?.courseTitle}</a>
              </h1>
              {/* <p>{Object.keys(item.instructors).map(function (k) { return item.instructors[k]['instructorName'] }).join(", ")}</p> */}
              <p>{item?.leadInstructor}</p>
              {item?.courseCardBtn != "hide" ? (
                <>
                  <div
                    className={`${styles.SessionCardFooter} ${"ButtonGroup"}`}
                  >
                    <div className={styles.ButtonContainer}>
                      {addToCartBtnLabelForGoToCourse[item.courseId] ==
                      "Go to Course" ? (
                        <Buttons
                          tooltip={
                            item.seats && item.totalEnrolled >= item.seats
                              ? "The course has reached its maximum enrollment capacity"
                              : ""
                          }
                          label={
                            addToCartBtnLabelForGoToCourse[item.courseId]
                              ? "Go to Course"
                              : ""
                          }
                          buttonColor={
                            addToCartBtnLabelForGoToCourse[item.courseId]
                              ? addToCartBtnLabelForGoToCourse[item.courseId] ==
                                "Go to Course"
                                ? "#0b9444"
                                : "#ffffff"
                              : "#004FE0"
                          }
                          color={"#fff"}
                          border={""}
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          disabled={
                            item.courseCardBtn == "disabled" ||
                            (item.seats && item.totalEnrolled >= item.seats)
                              ? item.courseCardBtn
                              : ""
                          }
                          onClick={() => gotoCourseDetails(item.courseId)}
                        />
                      ) : (
                        <Buttons
                          tooltip={getAddToCartToolTip(item)}
                          label={
                            addToCartBtnLabel[item.courseId]
                              ? addToCartBtnLabel[item.courseId]
                              : item.price == "Free"
                              ? "Enroll for Free"
                              : "Add to cart"
                          }
                          buttonColor={
                            addToCartBtnLabel[item.courseId]
                              ? addToCartBtnLabel[item.courseId] ==
                                "Go to Course"
                                ? "#0b9444"
                                : "#ffffff"
                              : "#004FE0"
                          }
                          color={
                            addToCartBtnLabel[item.courseId] == "Go to cart"
                              ? "#004FE0"
                              : "#fff"
                          }
                          border={
                            addToCartBtnLabel[item.courseId] == "Go to cart"
                              ? "2px solid #bcbcbc"
                              : ""
                          }
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          disabled={
                            item.courseCardBtn == "disabled" ||
                            (item.seatsStatus &&
                              item.seats &&
                              item.totalEnrolled >= item.seats)
                              ? item.courseCardBtn
                              : ""
                          }
                          onClick={
                            addToCartBtnLabel[item.courseId] == "Go to Course"
                              ? () => gotoCourseDetails(item.courseId)
                              : item.price == "Free"
                              ? () => {
                                  const userAuthenticated =
                                    localStorage.getItem("userAuthenticated");
                                  enrollNowHandler(item, userAuthenticated);
                                }
                              : () => addToCartHandler(item, i)
                          }
                        />
                      )}
                    </div>

                    <div className={styles.ShareButton}>
                      <div className={styles.ButtonContainer}>
                        <Buttons
                          icon={<ShareRoundedIcon />}
                          buttonColor="#fff"
                          color="#676C7B"
                          width="48px"
                          height="48px"
                          fontSize="30px"
                          borderRadius="100px"
                          border="#676C7B 1px solid"
                          onClick={() => handleOpen(item)}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </Grid>
      ))}
      {showAllBtnStatus ? (
        <>
          <Grid item xs={12} sm={12} md={12}>
            <div className="ShowAllButton">
              <Buttons
                label="Load More"
                buttonColor="#fff"
                color="#004FE0"
                width="content-fit"
                height="48px"
                fontSize="14px"
                borderRadius="4px"
                border="#004FE0 1px solid"
                onClick={showAllBtnHandler}
              />
            </div>
          </Grid>{" "}
        </>
      ) : (
        ""
      )}

      <ModalsResponsiveFullScreen
        open={open}
        handleClose={handleClose}
        width="552px"
        ModalTitle="Share this course"
        titileColor="#33B651"
        padding="20px"
        body={
          <div className="ModalSocialShare">
            <ShareThisCourse course={currentCourseData} showTitle={false} />
          </div>
        }
      />

      <CustomizedSnackbar
        open={showSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        handleClose={handleSnackbarClose}
      />
      {/* === Shopping Cart Drawer Start*/}
      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        title={`Shopping Cart (${cartItems?.length} Item${
          cartItems?.length > 1 ? "s" : ""
        })`}
        sideOpen="right"
        open={openShoppingDrawer}
        handleDrawerClose={CloseShoppingDrawer}
        Headerbackground="#004FE0"
        HeaderTextColor="#fff"
        body={<ShoppingCart setOpenSignUpModel={setOpenSignUpModel} />}
      />
      {/* === Shopping Cart Drawer End*/}
    </>
  );
}
export default CourseCard;
